import * as Sentry from "@sentry/vue";

/**
 * Sentry工具类，用于异常捕获和错误上报
 */
export default class SentryUtil {
  /**
   * 捕获消息
   * @param message 错误消息
   * @param level 错误级别
   * @param options 可选配置
   */
  public static captureMessage(message: string, level: "debug" | "info" | "warning" | "error" = "info", options?: { tags?: Record<string, any>; contexts?: Record<string, any> }): void {
    try {
      Sentry.captureMessage(message, { level, ...options });
    } catch (sentryError) {
      console.error("Sentry捕获消息失败:", sentryError);
    }
  }

  /**
   * 捕获HTTP请求错误
   * @param error 响应错误对象
   */
  public static captureHttpError(error: any): void {
    try {
      Sentry.captureException(error);
    } catch (sentryError) {
      console.error("Sentry捕获HTTP错误失败:", sentryError);
    }
  }
}
